module.exports = __webpack_public_path__ + "img/天力热熔机2.d361c961.jpg";